import { type GameFormParticipant, type GameFormUserParticipant } from '../form'
import { type DecoratedGameParticipant, type WithUserId } from '@terros/common'

export const toGameFormParticipant = (participant: DecoratedGameParticipant): GameFormParticipant => {
  if (participant.type === 'user')
    return {
      type: 'user',
      participantId: participant.participantId,
    }
  return {
    type: 'group',
    participantId: participant.participantId,
    name: participant.name,
    userIds: participant.users.map((user) => user.participantId),
  }
}

export const toGameFormUserParticipant = (user: WithUserId): GameFormUserParticipant => {
  return {
    type: 'user',
    participantId: user.userId,
  }
}
